import { nextYear, thisYear } from "../../../Footer/footer";

// utils/pdf/registrationTemplate.js
export const registrationTemplate = ({
  formData,
  priceSummaryUI,
  originalTotal,
  discountedTotal,
  voucherValid,
  formatCitiesForPDF
}) => `
<div style="font-family: Arial, sans-serif; padding: 10px; font-size: 10pt; display: flex; flex-direction: column; min-height: 100%;">
  <div style="flex: 0;">
    <h3 style="text-align: center; color: #dc3545; margin: 5px 0;">NIEC WORLD EDUCATION FESTIVAL ${thisYear} - ${nextYear}</h3>
    <h4 style="text-align: center; color: #000000; margin: 5px 0 10px 0;">Registration Summary & Commitment Statement</h4><br />
    
    <p style="color: #dc3545; margin: 5px 0;">For the university/institution who gets 50% off, there will be no accommodation provided</p>
    <h4 style="margin: 5px 0; color: #000000;">Personal Information</h4>
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; font-size: 9pt;">
      <tr style="background-color: #f8f9fa;">
        <th style="border: 1px solid #dee2e6; padding: 3px; text-align: left; width: 35%; color: #000000;">Field</th>
        <th style="border: 1px solid #dee2e6; padding: 3px; text-align: left; color: #000000;">Value</th>
      </tr>
      <tr>
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Full Name</td>
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">${formData.fullName || ""}</td>
      </tr>
      <tr style="background-color: #f8f9fa;">
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Institution</td>
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">${formData.institution || ""}</td>
      </tr>
      <tr>
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Official Representative</td>
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">${formData.officialRepresentative || ""}</td>
      </tr>
      <tr style="background-color: #f8f9fa;">
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Email</td>
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">${formData.email || ""}</td>
      </tr>
      <tr>
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Phone</td>
        <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">${formData.phone || ""}</td>
      </tr>
    </table>
    
    <br />
    <div style="display: flex; gap: 10px;">
      <div style="flex: 1;">
        <h4 style="margin: 5px 0; color: #000000;">Price Summary</h4>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; font-size: 9pt;">
          <tr style="background-color: #f8f9fa;">
            <th style="border: 1px solid #dee2e6; padding: 3px; text-align: left; color: #000000;">Price Details</th>
          </tr>
          ${priceSummaryUI.map(detail => {
  const formattedCities = formatCitiesForPDF(detail.cities);
  return `
                <tr>
                  <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">
                  <strong>${detail.scheduleName}</strong> <br />
                  ${detail.packageType} Package - AUD ${detail.price.toLocaleString('id-ID')} for ${detail.cityCount} <br />
                  <span style="font-size: 8pt; color: #000000;">${(formattedCities)}</span>
                  </td>
                </tr>
            `
}).join('')}
          <tr style="background-color: #f8f9fa;">
            <td style="border: 1px solid #dee2e6; padding: 3px; font-weight: bold; color: #000000;">
              ${voucherValid
    ? `Original Total: AUD ${originalTotal.toLocaleString('id-ID')}<br>
                   Discounted Total: AUD ${discountedTotal.toLocaleString('id-ID')}`
    : `Total: AUD ${discountedTotal.toLocaleString('id-ID')}`
  }
            </td>
          </tr>
        </table>
      </div>
      
      <div style="flex: 1;">
        <h4 style="margin: 5px 0; color: #000000;">Payment Information</h4>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; font-size: 9pt;">
          <tr style="background-color: #f8f9fa;">
            <th style="border: 1px solid #dee2e6; padding: 3px; text-align: left; width: 30%; color: #000000;">Field</th>
            <th style="border: 1px solid #dee2e6; padding: 3px; text-align: left; color: #000000;">Details</th>
          </tr>
          <tr>
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Bank</td>
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">OCBC NISP, BRANCH TEUKU UMAR DENPASAR BALI</td>
          </tr>
          <tr style="background-color: #f8f9fa;">
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Account Name</td>
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">CV Naresy Indonesia</td>
          </tr>
          <tr>
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Account Number</td>
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">160800014310</td>
          </tr>
          <tr style="background-color: #f8f9fa;">
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Swift Code</td>
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">NISPIDJA</td>
          </tr>
          <tr>
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Branch Code</td>
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">07160</td>
          </tr>
          <tr style="background-color: #f8f9fa;">
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">Bank Code</td>
            <td style="border: 1px solid #dee2e6; padding: 3px; color: #000000;">028</td>
          </tr>
        </table>
      </div>
    </div>

    <div style="flex: 1; margin-top: 15px;">
      <p style="margin: 5px 0; font-weight: bold; color: #000000;">Notes:</p>
      <div style="width: 100%; border: 1px solid #dee2e6; padding: 15px; min-height: 150px; margin-bottom: 10px; font-size: 9pt; color: #000000; background-color: #f8f9fa;">
        ${formData.notes ? formData.notes.replace(/\n/g, '<br>') : ''}
      </div>
    </div>
  </div>
  <!-- Signature section yang selalu berada di bawah -->
  <div style="flex: 0; margin-top: 30px; margin-bottom: 10px; font-size: 9pt;">
    <div style="display: flex;">
      <div style="flex: 1;">
        <p style="margin: 0 0 5px 0; color: #000000;"><strong>Place and Date:</strong></p>
        <div style="border-bottom: 1px solid #000; width: 80%;"></div>
      </div>
      <div style="flex: 1; text-align: center;">
        <p style="margin: 0 0 15px 0; color: #000000;"><strong>Signature:</strong></p><br /><br /><br />
        <div style="border-bottom: 1px solid #000; width: 80%; margin: 0 auto;"></div>
        <p style="margin: 5px 0 0 0; color: #000000;"><strong>${formData.fullName || ""}</strong><br>${formData.institution || ""}</p>
      </div>
    </div>
    
    <p style="font-size: 8pt; text-align: center; margin: 10px 0 0 0; color: #000000;">
      This is an official document from your NIEC World Education Festival ${thisYear} - ${nextYear} registration. Generated on: ${new Date().toLocaleDateString()}
    </p>
  </div>
</div>
`;